import { render, staticRenderFns } from "./InvoiceArea.vue?vue&type=template&id=223bfd90&"
import script from "./InvoiceArea.vue?vue&type=script&lang=js&"
export * from "./InvoiceArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports